import React, {useState} from 'react';
import '@components/consumption/consumption.scss';
import ConsumptionGaugeChart from '@components/module-components/consumtionGaugeChart/ConsumptionGaugeChart';
import ConsumptionLineChart from '@components/module-components/consumptionLineChart/ConsumptionLineChart';
import lineChartIcon from '@assets/images/icons/chart-line.svg';
import {useSelector} from 'react-redux';
import {translate} from '@src/helpers';
import {Translations} from '@constants/translate';

const Consumtion = ({dataChart, id}: any) => {
    const langData = useSelector((state: any) => state.currentLanguage) as any;
   const outsideClickListener = (event:any) => {
      const classList = Object.values(event.target.classList);
      const isClickOut = classList.find((item: any) => item === 'chartModal');
      if(isClickOut) {
         handleCloseModal();
      }
    }

   const pressESCListener = (event:any) => {
      if(event.keyCode === 27) {
         handleCloseModal();
      }
   }

   const handleOpenModal = () => {
      setOpenModal(true);
      document.documentElement.classList.add('modal-open');
      document.addEventListener('click', outsideClickListener);
      document.addEventListener('keyup', pressESCListener);
   }

   const handleCloseModal = () => {
      setOpenModal(false);
      document.documentElement.classList.remove('modal-open');
      document.removeEventListener('click', outsideClickListener);
      document.removeEventListener('keyup', pressESCListener);
    }

   const [ isOpenModal, setOpenModal ] = useState(false);

  return (
    <div className="consumtion" id={id}>
      <div className="consumtion_header">
        <h3 className="consumtion_title text-center">{translate(langData.localize, Translations['B2C.TITLE.ECO_SCORE'])}</h3>
        <div className="consumtion_desc">
          <div className="grade-desc">
            <div className="grade-desc_item">{translate(langData.localize, Translations['B2C.COMMON.BEST'])}</div>
            <div className="grade-desc_item grade-desc_item--a">A</div>
            <div className="grade-desc_item grade-desc_item--b">B</div>
            <div className="grade-desc_item grade-desc_item--c">C</div>
            <div className="grade-desc_item grade-desc_item--d">D</div>
            <div className="grade-desc_item grade-desc_item--e">E</div>
            <div className="grade-desc_item grade-desc_item--f">F</div>
            <div className="grade-desc_item">{translate(langData.localize, Translations['B2C.COMMON.WORST'])}</div>
          </div>
        </div>
      </div>

      <ConsumptionGaugeChart gaugeData={dataChart.gauge_chart}/>
      <span className="consumtion_more icon-text" onClick={handleOpenModal}><img src={lineChartIcon} alt=""/><span className="icon-text_content">{translate(langData.localize, Translations['B2C.COMMON.SHOW_MORE'])}</span></span>

      { isOpenModal && <ConsumptionLineChart lineData={dataChart.line_chart} onClose={handleCloseModal}/> }
    </div>
  );
}

export default Consumtion;
